<template>
  <div class="submit-assign-dialog-container">
    <div class="submit-devices">
      <v-row>
        <v-col cols="12">
          <h3>Assign to Vehicle</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-data-table
            :items="actions"
            :headers="headers"
            :hide-default-footer="true"
          >
            <template  
              v-slot:item.hasDevice="{ item }"
            >
              <svg 
                v-if="hasDevice(item)" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="red" 
                width="38px" 
                height="38px">
                <path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
              </svg>
            </template>

            <template  
              v-slot:item.target="{ item }"
            >
              <!-- Allow users to rename vehicle on creation -->
              <v-text-field
                v-if="item.isDir"
                v-model="item.updatedVehicleName"
                @input="vehicleNameUpdated(item)"
              ></v-text-field>

              <span 
                v-else
              >
                {{ item.target }}
              </span>
            </template>

          </v-data-table>
        </v-col>
      </v-row>

      <v-row v-if="anyExistingDevice" class="nudge-left">
        <v-col cols="1">
          <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 24 24" 
              fill="red" 
              width="38px" 
              height="38px">
              <path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
            </svg>
        </v-col>
        <v-col cols="11">
          <span class="warning-text">
            One or more vehicles currently have an assigned device. If you proceed these devices will be unassigned.
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="auto"
          class="mr-auto"
        >
          <div class="ctrl-btn cancel" @click="closeWindow">
            CANCEL
          </div>
        </v-col>
        <v-col cols="auto">
          <div class="ctrl-btn submit" @click="submit">
            PROCEED
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>

// import { Logger } from "aws-amplify"
// const logger = new Logger("Submit Assign")

export default {
  name: 'SubmitAssignDialog',
  props: {
    actions: {
      type: Array,
      required: true
    },
    org: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: ' ',
          value: 'hasDevice',
          align: 'left',
          sortable: false
        },
        {
          text: 'Install Tag',
          value: 'install_tag',
          align: 'left'
        },
        {
          text: 'Vehicle Name',
          value: 'target',
          align: 'left'
        },
        {
          text: 'Type',
          value: 'vehicle_type',
          align: 'left'
        },
      ],
      parsedActions: [],
      updatedName: ''
    }
  },
  computed: {
    anyExistingDevice() {
      let hasDevice =  this.actions.find(item => {
        return item.hasDevice.length > 0;
      });

      return hasDevice ? true : false;
    }
  },
  methods: {
    closeWindow(){
      this.$emit('closeSubmitAssign')
    },
    submit() {
      this.$emit('confirmAddToQue')
    },
    hasDevice(item) {
      return item.hasDevice.length > 0 ? true : false;
    },
    vehicleNameUpdated(item) {
      let payload = {
        id: item.id,
        name: item.updatedVehicleName
      };

      this.$emit('updatingVehicleName', payload);
    }
  }
}
</script>

<style lang="scss" scoped>
  .submit-assign-dialog-container {
    z-index: 9999;
    position: fixed;
    left: 0%;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4) !important;
    width: 100vw;
    height: 100vh;
    .submit-devices {
      background: white;
      margin: 0;
      position: relative;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 0;
      overflow: hidden;
      border: solid 2px;
      width: 1000px;
      padding: 1em;
      .header {
        background: #e0e0e0;
        border: solid 1px;
        text-align: center;
        padding: 0;
      }
      .org-select {
        padding-left: 1em;
      }
      .ctrl-btn {
        font-size: 20px;
        padding-bottom: .25em;
        padding-bottom: .25em;
        color: #0069bb;
        &:hover {
          cursor: pointer;
        }
      }
      .cancel {
        padding-left: 1em;
      }
      .submit {
        padding-right: 1em;
      }
    }
    .close-icon {
      top: 0;
      right: 0;
      position: absolute;
    }
    .nudge-left {
      padding-left: 1em;
    }
    .warning-text {
      color: red;
    }
  }
</style>